// import { CALL_API } from 'redux-api-middleware'
// import { push } from 'react-router-redux'
import {
  CREATE_VIDEO_SUCCESS,
} from './types'

import {
} from '../constant'

import {
  // token,
  // UploadRequest,
} from '../utils'

export const createVideo = (videoCreated) => {
  return {
    type: CREATE_VIDEO_SUCCESS,
    data: {
      videoCreated,
    },
  }
}




// WEBPACK FOOTER //
// ./src/actions/addNewCourse.js